module.exports = __webpack_public_path__ + "img/theme-c.47a017e2.png";